import React, { useEffect, useState } from 'react'
import PINInputField from './PINInputField'
import { useApp } from '../../../context/usePortal'

interface PINVerifactionPopupProps {
  handleVerificationProcessStatusChange: (status: boolean) => void
  handleAuthStatusChange: (status: string) => void
  noPinLimit: number
  resetPIN?: () => void
  scanAndPayWithOutPin?: boolean
}

const PINVerificationPopup: React.FC<PINVerifactionPopupProps> = ({
  handleVerificationProcessStatusChange,
  handleAuthStatusChange,
  noPinLimit,
  resetPIN,
  scanAndPayWithOutPin,
}) => {
  const { updatePIN, user, payWithOutPin } = useApp()
  const phoneNumber = user?.country_code + '-' + user?.user_phone_number
  const [pin, setPin] = useState<string>('')
  useEffect(() => {
    if (pin.length === 6) {
      VerifyPin()
    }
  }, [pin])
  const VerifyPin = async () => {
    handleVerificationProcessStatusChange(true)
    //verify the
    if (resetPIN) {
      const responseData = await updatePIN(pin, pin, noPinLimit)
      if (responseData?.response?.updated) {
        handleAuthStatusChange('succeed')
      } else {
        handleAuthStatusChange('failed')
      }
    } else {
      const { response } = await payWithOutPin(
        !!scanAndPayWithOutPin,
        noPinLimit,
        phoneNumber,
        pin,
      )
      if (response?.success) {
        handleAuthStatusChange('succeed')
        setTimeout(() => {
          window.location.reload()
        }, 1000)
      } else {
        handleAuthStatusChange('failed')
      }
    }
  }

  const handleChangePin = (newValue: string = '') => {
    setPin(newValue)
  }
  const handleForgetPin = () => {
    if (resetPIN) resetPIN()
  }

  return (
    <div>
      <h2 className="my-2 text-center text-xl font-bold capitalize">
        Enter PIN to continue
      </h2>
      <p className="text-center">Please enter your 6-digit PIN</p>
      <PINInputField length={6} onChangePin={handleChangePin} />
      <button
        type="button"
        className="mx-auto mt-2 block w-full text-center font-semibold capitalize underline"
        onClick={handleForgetPin}>
        Forget PIN?
      </button>
    </div>
  )
}

export default PINVerificationPopup
